import React, { FC } from 'react';
import { ButtonAsWrapper, FlexCol, FlexRow, H2Text } from '@minecraft.atoms';
import Icon from '@minecraft.icon';
import { SelectPlanSmProps } from './types';
import { PlanType } from '../usePlans';

const PlanCard: FC<{ plan: PlanType; selectedPlan: PlanType; setSelectedPlan: (plan: PlanType) => void }> = ({
  plan,
  selectedPlan,
  setSelectedPlan,
}) => {
  return (
    <ButtonAsWrapper aria-label={plan.title} onClick={() => setSelectedPlan(plan)}>
      <FlexCol
        borderSize={0.1}
        borderColor="default"
        borderPlacement="all"
        borderRadius="md"
        minHeight={6}
        minWidth={10}
        justifyContent="center"
        alignItems="center"
        gap="1"
        bgColor={selectedPlan.name === plan.name ? `${plan.temperature}PaywallDarkBg` : 'transparent'}
      >
        {plan.icon && <Icon name={plan.icon} themeColor="active" />}
        <H2Text>{plan.title}</H2Text>
      </FlexCol>
    </ButtonAsWrapper>
  );
};

export const SelectPlanSm: FC<SelectPlanSmProps> = ({ plans = [], setSelectedPlan, selectedPlan, loading }) => {
  if (plans.length <= 1 || loading) return null;
  return (
    <FlexRow alignContent="center" justifyContent="center" gap="2" w="full">
      {plans.map((p) => (
        <PlanCard key={p.name} plan={p} selectedPlan={selectedPlan} setSelectedPlan={setSelectedPlan} />
      ))}
    </FlexRow>
  );
};
